export default theme => ({
  root: {},
  formControl: {
    margin: theme.spacing(1),
    minWidth: '200px',
    width: '200px',
  },
  formControlSmall: {
    margin: theme.spacing(1),
    minWidth: '100px',
    width: '100px',
  },
  formControlMedium: {
    margin: theme.spacing(1),
    minWidth: '150px',
    width: '150px',
  },
  rowWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    margin: theme.spacing(0)
  }
});
